import React, { useEffect, useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Checkbox,
  Link,
} from '@material-ui/core';
import StartIcon from '@material-ui/icons/Star';
import { firestore } from '../configs/environments/firebase/firebaseApp';

const Title = ({ title }) => {
  return (
    <div className="flexContainer--startCenter">
      <div
        style={{
          width: '4px',
          height: '24px',
          borderRadius: '1px',
          backgroundColor: '#013957',
        }}
      ></div>
      <Typography
        color="primary"
        style={{
          marginLeft: 12,
          fontSize: 18,
          fontWeight: 'bold',
        }}
      >
        {title}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles({
  star: {
    color: '#ffc200',
  }
})

const Calification = ({ rating }) => {
  const classes = useStyles()
  return (
    <div className="flexContainer--startCenter">
      <StartIcon
        color="secondary"
        fontSize="large"
        classes={{colorSecondary: classes.star}}
      />
      <Typography color="primary" style={{ fontSize: 20, margin: '0 8px' }}>
        {rating}
      </Typography>
      <Typography style={{ fontSize: 14, color: '#10587f' }}>
        Satisfacción
      </Typography>
    </div>
  );
};

export default (props) => {
  const {
    opinion,
    rating,
    title,
    handleChange,
    handleChangeChecked,
    featured,
    show,
  } = props.item;

  let [rests, setRests] = useState();
  let [users, setUsers] = useState([]);

  useEffect(() => {
    getDocumentsSnapshots();
  }, []);

  const getDocumentsSnapshots = () => {
    let query = firestore
      .collection('client')
      .doc(props.item.clientUid)
      .get()
      .then(function (querySnapshot) {
        //console.log('querySnapshot', querySnapshot.data());
        setRests(querySnapshot.data());
      })
      .catch(function (error) {});
    //console.log('rests', rests);
  };

  const id = props.id;

  /*  let infoLaw = props.item.lawyerUser.get().then(function(doc) {
    if (doc.exists) {
        
    } else {
        // doc.data() will be undefined in this case
        
    }
}).catch(function(error) {
    
}); */

  function getUsers() {
    return props.item.lawyerUsers.get();
  }

  function getOpinios() {
    let datos = props.item.createdBy.get().then(function (documentSnapshot) {
      var data = documentSnapshot.data();

      return data;
    });
    return datos;
  }

  function populate(snap, key) {
    snap.forEach(function (documentSnapshot) {
      var data = documentSnapshot.data();
    });

    let array = [];
    snap.forEach((doc) => {
      let r = doc.data();
      r.id = doc.id;
      r[key] = convertRefToPromises(r[key]);
      array.push(resolveRefsFirst(r, key));
    });
    return Promise.all(array);
  }

  function convertRefToPromises(refs) {
    // no devuelve promesa sync
    let promises = refs.map((ref) => {
      return ref.get().then((doc) => doc.data());
    });
    return promises;
  }

  function resolveRefsFirst(r, key) {
    return convertPromisesToObject(r[key]).then((results) => {
      r[key] = results;
      return r;
    });
  }

  function convertPromisesToObject(array) {
    //si devuelve promesa
    return Promise.all(array).then((results) => results);
  }
  const [checked, setChecked] = React.useState(show);

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      <Card style={{ marginBottom: 16 }}>
        <CardHeader
          title={<Title title={rests && rests.name? rests.name : rests && rests.displayName ? rests.displayName: ''} />}
          action={
            <Checkbox
              checked={checked}
              onChange={handleChangeCheck}
              onClick={props.handleChangeChecked}
              color="secondary"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          }
          style={{ borderBottom: '0.5px solid #e7e7e7', paddingBottom: 6 }}
        />
        <CardContent style={{ paddingBottom: 0 }}>
          <Typography>{opinion}</Typography>
          <br />
          <Calification rating={rating} />
        </CardContent>
        <CardActions
          className="flexContainer--endCenter"
          style={{ padding: 16, paddingTop: 0 }}
        >
          <button
            //component="button"
            style={{
              backgroundColor: 'transparent',
              color: '#10587f',
              border: 'none',
              cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
              outline: 'none',
            }}
            onClick={()=> props.handleClickDelete(props.item.uidOpinion)}
          >
            Eliminar
          </button>
        </CardActions>
      </Card>
    </>
  );
};
